module.exports = __webpack_public_path__ + "static/img/success15.c0d49d13.png";